export default "__VITE_ASSET__336bb17a__"